var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44442 0.864014L0.316406 9.37608H3.43243L3.52743 10.0791L3.60343 10.5921H17.6635L17.4925 9.85108L15.6685 1.33902L15.5735 0.864014H2.44442ZM3.62243 2.08002H14.5855L16.1625 9.37608H4.66744L3.62243 2.08002ZM2.74843 4.64504L3.26143 8.16007H1.87442L2.74843 4.64504ZM6.56746 5.12005V6.33606H13.2555V5.12005H6.56746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.685de65f19c1600329679cc034b881e4.svg";
export { ForwardRef as ReactComponent };